export default "__VITE_ASSET__DEEOojlZ__"